import { Button } from "@/components/ui/button";
import { Card, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertTriangle, LogOut } from "lucide-react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import useAuthStore from "@/store/authStore";

export default function NoRestaurantPage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { logout } = useAuthStore();

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/auth");
    } catch (error) {
      console.error("Logout failed:", error);
      toast.error(i18n.t("auth.logoutError"));
    }
  };

  const handleContactSupport = () => {
    const supportEmail = "support@smrt-menu.online";
    toast.info(
      t("support.contactMessage", `Please contact support at: ${supportEmail}`)
    );
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4">
      <Card className="w-full max-w-lg">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-orange-100 dark:bg-orange-900/20">
            <AlertTriangle className="h-8 w-8 text-orange-600 dark:text-orange-400" />
          </div>
          <CardTitle className="text-2xl">{t("profile.noRestaurantFound")}</CardTitle>
          <CardDescription className="text-center mt-2">
            {t("profile.noRestaurantAdminMessage", "אין מסעדה המשויכת לחשבון שלך. אנא פנה לתמיכה בכתובת: support@smrt-menu.online")}
          </CardDescription>
        </CardHeader>
        <CardFooter className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Button onClick={handleContactSupport} className="w-full sm:w-auto">
            <AlertTriangle className="mr-2 h-4 w-4" />
            {t("support.contactAdmin", "פנה למנהל המערכת")}
          </Button>
          <Button onClick={handleLogout} variant="outline" className="w-full sm:w-auto">
            <LogOut className="mr-2 h-4 w-4" />
            {t("sidebar.logout")}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}